import { GET_INFRACTION_TYPES_BEGIN, GET_INFRACTION_TYPES_FAIL, GET_INFRACTION_TYPES_SUCCESS } from '../actions/mod';

const initialState = {
	infractionTypes: null,
	loadingInfractionTypes: false,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case GET_INFRACTION_TYPES_BEGIN:
			return {
				...state,
				loadingInfractionTypes: true,
			};
		case GET_INFRACTION_TYPES_SUCCESS:
			return {
				...state,
				infractionTypes: action.payload,
				loadingInfractionTypes: false,
			};
		case GET_INFRACTION_TYPES_FAIL:
			return {
				...state,
				infractionTypes: null,
				loadingInfractionTypes: false,
			};
		default:
			return state;
	}
};